export const defaultProps = {
    label: String,
    isDisabled: Boolean,
    placeholder: String,
    isRequired: {
        type: Boolean,
        default: true,
    },
    value: null,
    labelLinkText: { type: String, default: null },
    labelLinkUrl: { type: String, default: null },
}
